import {useAddressContext} from 'components/providers';
import {DishLunchSlider} from 'components/shared/DishLunchSlider';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse} from 'types';
import {isStauceni} from 'utils/addresses';

import {RestaurantsSection} from './all-restaurants-section';
import {NewRestaurantSection} from './new-restaurant-section';
import {RecomendedSection} from './recomended-section';

interface RestaurantContentProps {
  locale: string;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  coordinates: string;
}

export const RestaurantContent = ({locale, myFavorite, onEditFavorite, coordinates}: RestaurantContentProps) => {
  const {selectedAddress} = useAddressContext();
  const stauceniAddress = isStauceni(selectedAddress);
  return (
    <>
      {!stauceniAddress && (
        <RecomendedSection
          locale={locale}
          myFavorite={myFavorite}
          onEditFavorite={onEditFavorite}
          coordinates={coordinates}
        />
      )}
      <DishLunchSlider />
      <NewRestaurantSection
        myFavorite={myFavorite}
        onEditFavorite={onEditFavorite}
        locale={locale}
        coordinates={coordinates}
      />
      <RestaurantsSection
        myFavorite={myFavorite}
        onEditFavorite={onEditFavorite}
        locale={locale}
        coordinates={coordinates}
        disableCount={stauceniAddress}
      />
    </>
  );
};
